module.exports = __webpack_public_path__ + "static/media/banner.e02406e1.jpg";